import React from "react";
const Listloader = (props) => {
  return (
    <section className="content" style={{ minHeight: "120px" }}>
      <div className="container-fluid">
        <div className="lowloader"></div>
      </div>
    </section>
  );
};

export default Listloader;
